<div class="b-match" [class.b-match_empty]="isEmpty()" [class.b-match_scheduled]="status == 'scheduled'" [class.b-match_in_progress]="status == 'in_progress'" [class.b-match_finished]="status == 'finished'" [class.b-match_highlighted]="highlighted" id="match-{{ number }}">
  <div class="b-match__header">
    <div
      class="b-match__number"
    >
      <div
        class="duelNumberDivStyle"
        [ngClass]="tierNumberHighlightClass()"
      >
        #{{ number }}
      </div>
      <a
        *ngIf="videoLink !== ''"
        href="{{ videoLink }}"
        target="_blank"
        class="text-danger"
        title="Видео-трансляция встречи"
        [ngClass]="statusClassName"
      >
        <i class="fa-solid fa-video"></i>
      </a>
    </div>
    <div class="b-match__schedule d-n">
      <span *ngIf="table && status !== 'finished'">стол №{{ table }}{{ scheduledAt ? "," : "" }}</span>
      {{ scheduledAt }}
    </div>
  </div>
  <div
    class="b-match__body"
    [ngClass]="{
      'b-match__body_with-footer': looser_goes_to || winner_goes_to
    }"
  >
    <div
      class="b-match__player"
      [class.walkover]="has_walkover && !playerOne"
      [class.highlight]="highlightPlayerOne"
      (mouseenter)="mouseEnter(playerOneId)"
      (mouseleave)="mouseLeave(playerOneId)"
      (click)="openForManualAssign($event, 1)"
    >
      <div class="b-match__player-tnumber" *ngIf="playerOneTournamentNumber && isFirstRound === 'True'">
        {{ playerOneTournamentNumber }}
      </div>
      <div class="b-match__player-name" [title]="getPlayerOneName()">
        <span class="fi fi-{{ playerOneCountryCode }}" *ngIf="playerOneCountryCode"></span>
        {{ getShortenPlayerName(getPlayerOneName()) }}
      </div>
      <div
        class="b-match__player-score"
        *ngIf="playerOneScore != 0 || playerTwoScore != 0"
        [class.defeatedScoreStyle]="playerTwoScore > playerOneScore"
        [class.winnerScoreStyle]="playerTwoScore < playerOneScore"
      >
        {{ playerOneScore }}
      </div>
    </div>

    <div
      class="b-match__player"
      [class.walkover]="has_walkover && !playerTwo"
      [class.highlight]="highlightPlayerTwo"
      (mouseenter)="mouseEnter(playerTwoId)"
      (mouseleave)="mouseLeave(playerTwoId)"
      (click)="openForManualAssign($event, 2)"
    >
      <div class="b-match__player-tnumber" *ngIf="playerTwoTournamentNumber && isFirstRound === 'True'">
        {{ playerTwoTournamentNumber }}
      </div>
      <div class="b-match__player-name" [title]="getPlayerTwoName()">
        <span class="fi fi-{{ playerTwoCountryCode }}" *ngIf="playerTwoCountryCode"></span>
        {{ getShortenPlayerName(getPlayerTwoName()) }}
      </div>
      <div
        class="b-match__player-score"
        *ngIf="playerOneScore != 0 || playerTwoScore != 0"
        [class.defeatedScoreStyle]="playerTwoScore < playerOneScore"
        [class.winnerScoreStyle]="playerTwoScore > playerOneScore"
      >
        {{ playerTwoScore }}
      </div>
    </div>
  </div>
  <div class="b-match__footer" *ngIf="looser_goes_to && isFirstRound !== 'True'" (click)="scrollTo(looser_goes_to)">
    <div class="d-n text-start">Проигравший на #{{ looser_goes_to }}</div>
  </div>
  <div class="b-match__footer" *ngIf="winner_goes_to && showWinner()" (click)="scrollTo(winner_goes_to)">
    <div class="d-n text-start">Победитель на #{{ winner_goes_to }}</div>
  </div>
</div>
